import React from 'react';

export default class Page10 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="desktop ipad-portrait-show">
                                                <table className="ilead_v_sport tablesrink para-bottompad"
                                                       border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" align="left" valign="center"
                                                            width="20%">Motivational area
                                                        </th>
                                                        <th align="left" valign="top" width="40%">High (4-5)
                                                        </th>
                                                        <th colSpan="4" className=" green_curve1" align="left"
                                                            valign="top" width="40%">Low (1-2)
                                                        </th>

                                                    </tr>

                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="center"
                                                            width="20%">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Autonomy</strong></span>
                                                            </div>
                                                        </td>

                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%">
                                                            <ul className="greenbullet-list">
                                                                <li>Prefers to work independently</li>
                                                                <li>Self managing</li>
                                                                <li>Makes up own mind</li>
                                                                <li> Can appear distracted</li>
                                                                <li className="list-bottom-pad">Prefers to take
                                                                    control of situations where possible
                                                                </li>
                                                            </ul>
                                                            <p>Give them space and autonomy. Monitor to ensure
                                                                compliance and encourage them to join team
                                                                activities.</p>

                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%">
                                                            <ul className="greenbullet-list">
                                                                <li>Works well as part of a team</li>
                                                                <li>Reliant on the support of colleagues</li>
                                                                <li> Easily influenced by others</li>
                                                                <li className="list-bottom-pad"> Happy to let
                                                                    others take charge
                                                                </li>

                                                            </ul>
                                                            <p>Provide them with a central role in the team
                                                                where they have to work with others. Support
                                                                them if giving responsibility – but not too
                                                                much!</p>

                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="center"
                                                            width="20%">
                                                            <div className="paddingcenter5"><span
                                                                className="subtitle-table"><strong>Variety</strong></span>
                                                            </div>
                                                        </td>

                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="40%">
                                                            <ul className="greenbullet-list">
                                                                <li> Excited by new ideas and shows innovation
                                                                    and creativity
                                                                </li>
                                                                <li>Energised when beginning things, less so by
                                                                    completing them!
                                                                </li>
                                                                <li> Can become bored or distracted</li>
                                                                <li className="list-bottom-pad"> May concentrate
                                                                    on own interests
                                                                </li>

                                                            </ul>
                                                            <p>Delegate activities to them, keep them busy and
                                                                involve them in creative tasks and projects.</p>

                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="40%">
                                                            <ul className="greenbullet-list">
                                                                <li>May build on existing processes</li>
                                                                <li> Prefers routine</li>
                                                                <li> Gets upset by change and finds this hard to
                                                                    deal with
                                                                </li>
                                                                <li className="list-bottom-pad"> Likes to work
                                                                    on one thing at a time
                                                                </li>

                                                            </ul>
                                                            <p>Give them clear instructions and limit the number
                                                                of tasks given at any one time. Clearly explain
                                                                any change and support them through it.</p>

                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="center"
                                                            width="20%">
                                                            <div className="paddingcenter7"><span
                                                                className="subtitle-table"><strong>Structure</strong></span>
                                                            </div>
                                                        </td>

                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%">
                                                            <ul className="greenbullet-list">
                                                                <li> Highly organised and plans work well in
                                                                    advance
                                                                </li>
                                                                <li> Very reliable and works well to deadlines
                                                                </li>
                                                                <li> Dislikes ambiguity and uncertainty</li>
                                                                <li className="list-bottom-pad"> Communicates
                                                                    frequently, clearly and consistently
                                                                </li>

                                                            </ul>
                                                            <p>Provide clear structure and frameworks. Give
                                                                early deadlines to work towards. Conduct regular
                                                                review sessions.</p>

                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%">
                                                            <ul className="greenbullet-list">
                                                                <li>Carefree approach, works well with flexible
                                                                    deadlines
                                                                </li>
                                                                <li>Tends to work in bursts of activity</li>
                                                                <li>Lacks structure and process</li>
                                                                <li className="list-bottom-pad">Infrequent or
                                                                    irregular communication
                                                                </li>

                                                            </ul>
                                                            <p>Give time and space for work to be completed.
                                                                Don’t be too prescriptive. Expect work to be
                                                                done but without regular updates!</p>

                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%">
                                                            <div className="paddingcenter9"><span
                                                                className="subtitle-table"><strong>Care</strong></span>
                                                            </div>
                                                        </td>

                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="40%">
                                                            <ul className="greenbullet-list">
                                                                <li>Considerate towards others in the team</li>
                                                                <li>Shows genuine concern for colleagues’
                                                                    welfare
                                                                </li>
                                                                <li>Empathetic and supportive</li>
                                                                <li className="list-bottom-pad">High levels of
                                                                    tolerance and patience
                                                                </li>

                                                            </ul>
                                                            <p>Give them a role where they can help others learn
                                                                or develop. Ensure they remain focused on tasks
                                                                as well as people.</p>

                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="40%">
                                                            <ul className="greenbullet-list">
                                                                <li>Not overtly caring towards other team
                                                                    members
                                                                </li>
                                                                <li>Task focused rather than interested in
                                                                    people’s lives
                                                                </li>
                                                                <li className="list-bottom-pad"> May walk over
                                                                    others’ feelings to get work completed
                                                                </li>


                                                            </ul>
                                                            <p>Give them a more task-focused role. Ensure they
                                                                consider others before taking action.</p>

                                                        </td>

                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">

                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Motivational
                                                            area
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Autonomy</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">High (4-5)</td>
                                                        <td valign="top">
                                                            <ul className="greenbullet-list">
                                                                <li>Sociable, outgoing and talkative</li>
                                                                <li> Brings people together</li>
                                                                <li> Can modify their behaviour with different
                                                                    people
                                                                </li>
                                                                <li className="list-bottom-pad">Avoids conflict
                                                                    with colleagues
                                                                </li>

                                                            </ul>
                                                            <p>Use these people to bring the team together. You
                                                                could allocate them a co-ordination role in the
                                                                team. Ensure that they have contact with
                                                                people.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">Low
                                                            (1-2)
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <ul className="greenbullet-list">
                                                                <li>Works well as part of a team</li>
                                                                <li>Reliant on the support of colleagues</li>
                                                                <li> Easily influenced by others</li>
                                                                <li className="list-bottom-pad"> Happy to let
                                                                    others take charge
                                                                </li>

                                                            </ul>
                                                            <p>Provide them with a central role in the team
                                                                where they have to work with others. Support
                                                                them if giving responsibility – but not too
                                                                much!</p>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Motivational
                                                            area
                                                        </th>
                                                        <td className=" green_curve1">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Variety </strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">High (4-5)</td>
                                                        <td valign="top" className="darkgreen">
                                                            <ul className="greenbullet-list">
                                                                <li> Excited by new ideas and shows innovation
                                                                    and creativity
                                                                </li>
                                                                <li>Energised when beginning things, less so by
                                                                    completing them!
                                                                </li>
                                                                <li> Can become bored or distracted</li>
                                                                <li className="list-bottom-pad"> May concentrate
                                                                    on own interests
                                                                </li>

                                                            </ul>
                                                            <p>Delegate activities to them, keep them busy and
                                                                involve them in creative tasks and projects.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">Low
                                                            (1-2)
                                                        </td>
                                                        <td valign="top" id="m-border-right">
                                                            <ul className="greenbullet-list">
                                                                <li>May build on existing processes</li>
                                                                <li> Prefers routine</li>
                                                                <li> Gets upset by change and finds this hard to
                                                                    deal with
                                                                </li>
                                                                <li className="list-bottom-pad"> Likes to work
                                                                    on one thing at a time
                                                                </li>

                                                            </ul>
                                                            <p>Give them clear instructions and limit the number
                                                                of tasks given at any one time. Clearly explain
                                                                any change and support them through it.</p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Motivational
                                                            area
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Structure</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">High (4-5)</td>
                                                        <td valign="top">
                                                            <ul className="greenbullet-list">
                                                                <li> Highly organised and plans work well in
                                                                    advance
                                                                </li>
                                                                <li> Very reliable and works well to deadlines
                                                                </li>
                                                                <li> Dislikes ambiguity and uncertainty</li>
                                                                <li className="list-bottom-pad"> Communicates
                                                                    frequently, clearly and consistently
                                                                </li>

                                                            </ul>
                                                            <p>Provide clear structure and frameworks. Give
                                                                early deadlines to work towards. Conduct regular
                                                                review sessions.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">Low
                                                            (1-2)
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <ul className="greenbullet-list">
                                                                <li>Carefree approach, works well with flexible
                                                                    deadlines
                                                                </li>
                                                                <li>Tends to work in bursts of activity</li>
                                                                <li>Lacks structure and process</li>
                                                                <li className="list-bottom-pad">Infrequent or
                                                                    irregular communication
                                                                </li>

                                                            </ul>
                                                            <p>Give time and space for work to be completed.
                                                                Don’t be too prescriptive. Expect work to be
                                                                done but without regular updates!</p>

                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Motivational
                                                            area
                                                        </th>
                                                        <td className=" green_curve1">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Care </strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">High (4-5)</td>
                                                        <td valign="top" className="darkgreen">
                                                            <ul className="greenbullet-list">
                                                                <li>Considerate towards others in the team</li>
                                                                <li>Shows genuine concern for colleagues’
                                                                    welfare
                                                                </li>
                                                                <li>Empathetic and supportive</li>
                                                                <li className="list-bottom-pad">High levels of
                                                                    tolerance and patience
                                                                </li>

                                                            </ul>
                                                            <p>Give them a role where they can help others learn
                                                                or develop. Ensure they remain focused on tasks
                                                                as well as people.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">Low
                                                            (1-2)
                                                        </td>
                                                        <td valign="top" id="m-border-right">
                                                            <ul className="greenbullet-list">
                                                                <li>Not overtly caring towards other team
                                                                    members
                                                                </li>
                                                                <li>Task focused rather than interested in
                                                                    people’s lives
                                                                </li>
                                                                <li className="list-bottom-pad"> May walk over
                                                                    others’ feelings to get work completed
                                                                </li>


                                                            </ul>
                                                            <p>Give them a more task-focused role. Ensure they
                                                                consider others before taking action.</p>


                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>

                                            </div>
                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page9')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div onClick={this.props.handleChangePage('Page11')}
                                                                          className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}